<template lang="pug">
  #ProgramDetails
    WtTitle(h3) Program Details
    BField(
      :type="{ 'is-danger': errors.has('program-name') }"
      :message="errors.first('program-name')"
    )
      WtLabel(
        slot="label"
        text="Program Name"
        label-for="program-name"
        required
      )
      BInput(
        placeholder="Program name"
        v-model="programName"
        name="program-name"
        v-validate="'required'"
      )
    BField(
      :type="{ 'is-danger': errors.has('program-url') }"
      :message="errors.first('program-url')"
    )
      UniquenessCheck(
        is-url
        label="Program URL"
        entity="programUrl"
        placeholder="Program URL"
        v-model="programUrl"
        @validName="onValidProgramUrl"
        name="program-url"
        v-validate="'required'"
      )
    BField(label="Select Program Type")
      BSelect(
        placeholder="Choose Type"
        v-model="programType"
      )
        option(
          v-for="(type, index) in tiers"
          :key="index"
          :value="type.value"
        )
          | {{ type.label }}
    BField(
      :type="{ 'is-danger': errors.has('seats') }"
      :message="errors.first('seats')"
      v-if="!isManagedProgram"
    )
      WtLabel(
        slot="label"
        text="Number of Participants"
        label-for="seats"
        required
        subLabel="You can add more at any time."
      )
      BInput(
        placeholder="50"
        :min="1"
        type="number"
        v-model="seats"
        name="seats"
        v-validate.disable="'required'"
      )
    BField(
      :type="{ 'is-danger': errors.has('totalEligibleEmployees') }"
      :message="errors.first('totalEligibleEmployees')"
      v-if="isManagedProgram"
    )
      WtLabel(
        slot="label"
        text="Number Eligible"
        label-for="totalEligibleEmployees"
        subLabel="How many people are eligible to register for your program? This can be an estimate."
      )
      BInput(
        placeholder="500"
        :min="1"
        type="number"
        v-model="totalEligibleEmployees"
        name="totalEligibleEmployees"
        v-validate.disable=""
      )

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";

export default {
  name: "ProgramDetails",

  components: { WtButton, WtLabel, WtTitle, UniquenessCheck },

  data() {
    return {
      tiers: [
        {
          value: "bewellcore",
          label: "Be Well Core"
        },
        {
          value: "bewellplus",
          label: "Be Well Plus"
        },
        {
          value: "bewellpro",
          label: "Be Well Pro"
        }
      ],
      totalEligibleEmployees: "",
      seats: 1,
      seatsTooltip: ``,
      programName: null,
      programNameTooltip: ``,
      programType: "bewellcore",
      programUrl: null,
      isProgramUrlValid: false,
      programUrlTooltip: ``
    };
  },

  computed: {
    formData() {
      return {
        totalEligibleEmployees: this.totalEligibleEmployees,
        seats: this.seats,
        tiers: this.programType,
        programName: this.programName,
        programUrl: this.programUrl
      };
    },

    isAllValid() {
      return (
        !this.errors.any() &&
        this.isProgramUrlValid &&
        this.seats > 0 &&
        !this._.isEmpty(this.programName)
      );
    },

    isManagedProgram() {
      return this.$route.path.includes("managed");
    }
  },

  watch: {
    isAllValid() {
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    },

    seats() {
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    },

    programType() {
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    }
  },

  methods: {
    onValidProgramUrl($event) {
      this.isProgramUrlValid = $event;
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    },
    resetState() {
      this.totalEligibleEmployees = "";
      this.seats = 1;
      this.seatsTooltip = ``;
      this.programName = null;
      this.programNameTooltip = ``;
      this.programType = "bewellcore";
      this.programUrl = null;
      this.isProgramUrlValid = false;
      this.programUrlTooltip = ``;
      this.$validator.reset();
    }
  }
};
</script>
